import React, { useState, useEffect, useContext, Fragment } from "react";
import Box from "@mui/material/Box";
import {
  Grid,
  Paper,
  Tab,
  Tabs,
  DialogTitle,
  DialogActions,
  Autocomplete,
  FormHelperText,
} from "@mui/material";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Typography from "@mui/material/Typography";
import { FilterMatchMode } from "primereact/api";
import { TabContext, TabPanel, TabList } from "@mui/lab";
import FormControl from "@mui/material/FormControl";
import InputBase from "@mui/material/InputBase";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import MultiSelect from "../common/MultiSelect";
import states from "../../data/StateLookup.json";
import Checkbox from "@mui/material/Checkbox";
import axios from "axios";
import { borderLeft } from "@mui/system";
import { Button as PrimeButton } from "primereact/button";
import CustomDialog from "../common/CustomDialog";
import ApproverTable from "./ApproverTable";
import AuthContext from "../../context/auth/AuthContext";
import { Button } from "@mui/material";
import ApprovalConfigToolbox from "./ApprovalConfigToolbox"
import ApprovalConfigHistory from "./ApprovalConfigHistory";
import { styled } from "@mui/material/styles";
import _ from "lodash";
import Loader from "../common/Loader";
import { CircularProgress } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { TrackNowButton } from "../ui/TrackNowButton";
import { TrackNowTextField } from "../ui/TrackNowTextField";
import { TrackNowSelect } from "../ui/TrackNowSelect";
import { TrackNowRadio } from "../ui/TrackNowRadio";
import { GoogleMaterialIcon } from "../ui/GoogleMaterialIcon";
import { GoogleIconButton } from "../ui/GoogleIconButton";
import { tokens } from "../../theme/tokens";

const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function ApprovalConfig() {
  const [name, setName] = React.useState("");
  const [state, setState] = React.useState("");
  const [selectCustomer, setSelectedCustomer] = useState(null);
  const [selectedCustomerObj, setSelectCustomerObj] = useState(null);
  const [customerList, setCustomerList] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  const [approverList, setApproverList] = useState([]);
  const [clientApproverList, setClientApproverList] = useState([]);
  const [approverTableData, setApproverTableData] = useState([]);
  const [approverMasterTableData, setApproverMasterTableData] = useState([]);
  const [value, setValue] = React.useState("");
  const [selectedRadio, setSelectedRadio] = React.useState("");
  const [selectedApproverData, setSelectedApproverData] = React.useState([]);
  const [isPopUpVisible, setIsPopUpVisible] = useState(false);
  const [selectReset, setSelectReset] = useState(false);
  const [approverId, setApproverId] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [tabValue, setTabValue] = useState("1");
  const [activityHistory, setActivityHistory] = React.useState([]);
  const [showHistory, setShowHistory] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState([]);
  // const [sendapproverList,setSendApproverList]=useState([])
  const [masterApproverList, setMasterApproverList] = React.useState("");
  const [masterApproverId, setMasterApproverId] = useState(null);
  const [masterSelectedRadio, setMasterSelectedRadio] = React.useState("");
  const [masterSelectedState, setMasterSelectedState] = useState([]);
  const [masterSelectedApproverData, setMasterSelectedApproverData] =
    React.useState([]);
  const [deleteData, SetDeleteData] = React.useState(null);
  const [isDefaultData, setIsDefaultData] = React.useState(null);
  const [openChangeDefault, setOpenChangeDefault] = React.useState(false);
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [showConfirmDialog, setShowConfirmDialog] = React.useState(false);
  const [confirmHeader, setConfirmHeader] = React.useState("Confirmation");
  const [confirmMessage, setConfirmMessage] = React.useState("");
  const [selectedTableRow, setSelectedTableRow] = React.useState("");
  const [selectedMasterTableRow, setSelectedMasterTableRow] =
    React.useState("");
  const [errors, setErrors] = useState({});
  const [masterErrors, setMasterErrors] = useState({});
  const authContext = useContext(AuthContext);
  const [isLoadingTable, setIsLoadingTable] = useState(false);
  // const clientFilingContext = useContext(ClientFilingMasterContext);
  const { authUser } = authContext;
  // const { changeFilingApprover } = clientFilingContext;
  //Get Customer List
  const getCustomerList = async () => {
    try {
      let res = await axios.get(`${API_BASE_URL}/Customer/CustomerList`);
      setCustomerList(res.data);
      getApproverList(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getLists();
  }, []);

  const getLists = async () => {
    await getCustomerList();
    await getUserList();
  };

  //Get User List
  const getUserList = async () => {
    try {
      let res = await axios.get(`${API_BASE_URL}/Application/UserRole`);
      console.log("data#", res.data);
      const filteredApprovalList = res.data.filter(
        (user) =>
          user.roleName === "Admin" ||
          user.roleName === "JSISME" ||
          user.roleName === "JSIPOC"
      );
      console.log("filteredApprovalList", filteredApprovalList);
      const uniqueByUserName = Array.from(
        new Map(
          filteredApprovalList.map((user) => [
            user.userName,
            user,
          ])
        ).values()
      );
      console.log("filteredApprovalList uniqueByUserName", uniqueByUserName);

      setApproverList(uniqueByUserName);
    } catch (error) {
      console.log(error);
    }
  };

  console.log("approvalList$", approverList);
  //Get Approver List
  const getApproverList = async (clientList) => {
    setIsLoadingTable(true);
    try {
      let res = await axios.get(`${API_BASE_URL}/Application/ListApprovers`);
      let res1 = res.data.data.filter((ele) => ele.filingType === "ClientFiling");
      let res2 = res.data.data.filter((ele) => ele.filingType === "MasterFiling");
      console.log("ApproverList res", res1);
      let appoverTable = res1.filter((ele) => ele.customerId !== null && ele.filingType === "ClientFiling");
      console.log("appoverTable", appoverTable, clientList);
      appoverTable = appoverTable.map((approver) => {
        console.log("-->appoverTable", approver);
        let client = clientList.filter(
          (ele) => ele.customerId === approver.customerId
        )[0];
        approver.client = client ? client.customerName : "";
        return approver;
      });
      const groupByClient = appoverTable.reduce((group, product) => {
        const { client } = product;
        group[client] = group[client] ?? [];
        group[client].push(product);
        return group;
      }, {});

      console.log("appoverTable--->>", appoverTable, groupByClient);

      for (const client in groupByClient) {
        console.log(`${client}: ${groupByClient[client]}`);
        let groupByState = groupByClient[client].reduce((states, ele) => {
          const { state, juristiction } = ele;
          if (juristiction === "Federal") {
            states["Federal"] = states["Federal"] ?? [];
            states["Federal"].push(ele);
          } else {
            states[state] = states[state] ?? [];
            states[state].push(ele);
          }
          return states;
        }, {});
        console.log("appoverTable--->> groupByState", groupByState);
        groupByClient[client] = { ...groupByState };
      }
      Object.entries(groupByClient).forEach(([clientName, value]) => {
        console.log("sendMasterApprover clients", clientName, value);
        Object.entries(value).forEach((stateName) => {
          console.log("sendMasterApprover state", stateName[1]);
          const hasDefault = stateName[1].some((ele) => ele.isdefault);
          if (!hasDefault) {
            stateName[1][0].isdefault = true;
            groupByClient[clientName][stateName[0]] = stateName[1];
            // updateApprover([stateName[1]]);
          }
        });
      });
      console.log("&&appoverTable--->>", appoverTable, groupByClient);
      setApproverTableData(groupByClient);

      //master table data
      let masterApproverTable = res2
        .filter((ele) => ele.customerId === null && ele.filingType === "MasterFiling")
        .reduce((states, ele) => {
          const { state, juristiction } = ele;
          // console.log("&&appoverTable--->>", state, juristiction);
          if (juristiction === "Federal") {
            states["Federal"] = states["Federal"] ?? [];
            states["Federal"].push(ele);
          } else {
            states[state] = states[state] ?? [];
            states[state].push(ele);
          }
          return states;
        }, {});

      Object.entries(masterApproverTable).forEach(([i, states]) => {
        console.log("sendMasterApprover states", i, states);
        const hasDefault = states.some((ele) => ele.isdefault);
        if (!hasDefault) {
          states[0].isdefault = true;
          masterApproverTable[i] = states;
          updateMasterApprover([states[0]]);
        }
      });
      console.log("&&masterApproverTable--->>", masterApproverTable);
      setApproverMasterTableData(masterApproverTable);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingTable(false);
    }
  };

  const validate = () => {
    let errors = {};
    if (!name) {
      errors.name = "Client Name is required";
    }
    if (!value) {
      errors.value = "Approver Name is required";
    }
    if (!selectedRadio) {
      errors.radio = "Please select Jurisdiction";
    }
    if (selectedRadio === "State" && selectedState.length === 0) {
      errors.stateInfo = "Please select Jurisdiction State";
    }
    console.log("validate", errors);
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFocus = (name) => {
    setErrors({ ...errors, [name]: undefined });
  };

  const validateMaster = () => {
    let errors = {};
    console.log("validateMaster", masterApproverList);
    if (!masterApproverList) {
      errors.masterApproverList = "Approver Name is required";
    }
    if (!masterSelectedRadio) {
      errors.masterRadio = "Please select Jurisdiction";
    }
    if (masterSelectedRadio === "State" && masterSelectedState.length === 0) {
      errors.masterSelectedState = "Please select Jurisdiction State";
    }

    console.log("validate Master", errors);
    setMasterErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleMasterFocus = (name) => {
    setMasterErrors({ ...errors, [name]: undefined });
  };

  const [filters, setFilters] = useState({
    client: { value: null, matchMode: FilterMatchMode.CONTAINS },
    approverName: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    juristiction: { value: null, matchMode: FilterMatchMode.CONTAINS },
    state: { value: null, matchMode: FilterMatchMode.CONTAINS },
    isdefault: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  // const updateApprover= async (data) => {
  //   console.log("sendMasterApprover", data);

  //   Object.entries(data).forEach(([i, iStates]) => {
  //     console.log("sendMasterApprover ele", iStates);

  //     const states = iStates.filter((item) => {
  //       console.log(
  //         "Type ele",
  //         typeof item.approverId,
  //         typeof isDefaultData.oldApproverId,
  //         isDefaultData.oldApproverId,
  //         isDefaultData.approverId
  //       );
  //       return (
  //         item.customerId === isDefaultData.customerId &&
  //         item.state === isDefaultData.stateName &&
  //         (item.approverId === isDefaultData.approverId ||
  //           item.approverId === isDefaultData.oldApproverId)
  //       );
  //     });
  //     console.log("sendMasterApprover ele states", states);
  //     states.forEach(async (ele) => {
  //       let postObj = {
  //         id: ele.id,
  //         approverId: ele.approverId,
  //         approverName: ele.approverName,
  //         customerId: ele.customerId,
  //         juristiction: ele.juristiction,
  //         state: ele.state,
  //         isdefault: ele.isdefault,
  //         approverGroupId: 1,
  //         filingType: "ClientFiling",
  //         // createDate: 2023-03-28T03:53:25.589Z,
  //         createUser: "string",
  //         // updateDate: 2023-03-28T03:53:25.589Z,
  //         updateUser: "string",
  //       };
  //       console.log("send data is passing", postObj);

  //       await axios
  //         .put(`${API_BASE_URL}/Application/UpdateApprovers`, postObj)
  //         .then(async (res) => {
  //           console.log("send data res", res);
  //           if (res.data.errorMessage) {
  //             // showAlert("Error", res.data.errorMessage, "error");
  //             setAlertMessage(res.data.errorMessage);
  //             setShowAlert(true);
  //             handleReset();
  //           } else {
  //             if (ele.approverId === isDefaultData.approverId) {
  //               try {
  //                 // const reassignPayload = {
  //                 //   oldApproverId: isDefaultData.oldApproverId,
  //                 //   newApproverId: ele.approverId,
  //                 //   state: ele.state,
  //                 //   customerId: ele.customerId,
  //                 // };
  //                 // console.log("Reassign Payload", reassignPayload);
  //                 // const res = await changeFilingApprover(reassignPayload);
  //                 // console.log("ChangeApprover Res", res);
  //                 setAlertMessage("Successfully updated default Approver");
  //                 setShowAlert(true);
  //                 handleReset();
  //                 getCustomerList();
  //                 setIsDefaultData(null);
  //               } catch (error) {
  //                 setAlertMessage(
  //                   "Unexpected Error Occured while reassiging the Workflow(s)"
  //                 );
  //                 setShowAlert(true);
  //                 handleReset();
  //                 setIsDefaultData(null);
  //               }
  //             } else {
  //               setAlertMessage("Successfully updated the Approver(s)");
  //               setShowAlert(true);
  //               handleReset();
  //               getCustomerList();
  //               setIsDefaultData(null);
  //             }
  //           }
  //         });
  //     });
  //   });
  // };
  const updateApprover = async (data) => {
    setIsLoadingTable(true);
    console.log("sendMasterApprover", data);
    Object.entries(data).forEach(([i, iStates]) => {
      console.log("sendMasterApprover ele", iStates);

      const states = iStates.filter((item) => {
        console.log(
          "Type ele",
          typeof item.approverId,
          typeof isDefaultData.oldApproverId,
          isDefaultData.oldApproverId,
          isDefaultData.approverId
        );
        return (
          item.customerId === isDefaultData.customerId &&
          item.state === isDefaultData.stateName &&
          (item.approverId === isDefaultData.approverId ||
            item.approverId === isDefaultData.oldApproverId)
        );
      });
      console.log("sendMasterApprover ele states", states);
      states.forEach(async (ele) => {
        let postObj = {
          id: ele.id,
          approverId: ele.approverId,
          approverName: ele.approverName,
          customerId: ele.customerId,
          juristiction: ele.juristiction,
          state: ele.state,
          isdefault: ele.isdefault,
          approverGroupId: 1,
          filingType: "ClientFiling",
          // createDate: 2023-03-28T03:53:25.589Z,
          createUser: ele.createUser,
          // updateDate: 2023-03-28T03:53:25.589Z,
          updateUser: authUser.userId + "",
        };
        console.log("send data is passing", postObj);

        await axios
          .put(`${API_BASE_URL}/Application/UpdateApprovers?Id=${postObj.id}`, postObj)
          .then(async (res) => {
            console.log("send data res", res);
            if (res.data.errorMessage) {
              // showAlert("Error", res.data.errorMessage, "error");
              setIsLoadingTable(false);
              setAlertMessage(res.data.errorMessage);
              setShowAlert(true);
              handleReset();
            } else {
              if (ele.approverId === isDefaultData.approverId) {
                try {
                  // const reassignPayload = {
                  //   oldApproverId: isDefaultData.oldApproverId,
                  //   newApproverId: ele.approverId,
                  //   state: ele.state,
                  //   customerId: ele.customerId,
                  // };
                  // console.log("Reassign Payload", reassignPayload);
                  // const res = await changeFilingApprover(reassignPayload);
                  // console.log("ChangeApprover Res", res);
                  setIsLoadingTable(false);
                  setAlertMessage("Successfully updated default Approver");
                  setShowAlert(true);
                  handleReset();
                  getCustomerList();
                  setIsDefaultData(null);
                } catch (error) {
                  setIsLoadingTable(false);

                  setAlertMessage(
                    "Unexpected Error Occured while reassiging the Workflow(s)"
                  );
                  setShowAlert(true);
                  handleReset();
                  setIsDefaultData(null);
                }
              } else {
                setIsLoadingTable(false);
                setAlertMessage("Successfully updated the Approver(s)");
                setShowAlert(true);
                handleReset();
                getCustomerList();
                setIsDefaultData(null);
              }
            }
          });
      });
    });
  };
  const updateMasterApprover = async (data) => {
    setIsLoadingTable(true);
    console.log("sendMasterApprover", data);
    const processData = isDefaultData
      ? data.filter(
        (item) =>
          item.state === isDefaultData.stateName &&
          (item.approverId === isDefaultData.approverId ||
            item.approverId === isDefaultData.oldApproverId)
      )
      : data;
    processData.forEach(async (ele) => {
      let postObj = {
        id: ele.id,
        approverId: ele.approverId,
        approverName: ele.approverName,
        customerId: ele.customerId,
        juristiction: ele.juristiction,
        state: ele.state,
        isdefault: ele.isdefault,
        approverGroupId: 1,
        filingType: "MasterFiling",
        // createDate: 2023-03-28T03:53:25.589Z,
        createUser: ele.createUser,
        // updateDate: 2023-03-28T03:53:25.589Z,
        updateUser: authUser.userId + "",
      };
      console.log("send data is passing", postObj);
      console.log("updateMasterApprover", "data", data, "processData", processData, "postObj", postObj)
      await axios
        .put(`${API_BASE_URL}/Application/UpdateApprovers?Id=${postObj.id}`, postObj)
        .then(async (res) => {
          console.log("send data res", res);
          if (res.data.errorMessage) {
            setIsLoadingTable(false);
            setAlertMessage(res.data.errorMessage);
            setShowAlert(true);
            handleReset();
            setIsDefaultData(null);
          } else {
            // showAlert("Success", "Successfully added Approver", "success");
            if (isDefaultData && ele.approverId === isDefaultData.approverId) {
              try {
                // const reassignPayload = {
                //   oldApproverId: isDefaultData.oldApproverId,
                //   newApproverId: ele.approverId,
                //   state: ele.state,
                // };
                // console.log("Reassign Payload", reassignPayload);
                // const res = await changeFilingApprover(reassignPayload);
                // console.log("ChangeApprover Res", res);
                setIsLoadingTable(false);
                setAlertMessage("Successfully updated default Approver");
                setShowAlert(true);
                handleReset();
                getCustomerList();
                setIsDefaultData(null);
              } catch (error) {
                setIsLoadingTable(false);
                setAlertMessage(
                  "Unexpected Error Occured while reassiging the Workflow(s)"
                );
                setShowAlert(true);
                handleReset();
                setIsDefaultData(null);
              }
            } else {
              setIsLoadingTable(false);
            }
          }
        });
    });
  };

  //on Submit
  const sendApprover = async (data) => {
    setIsLoadingTable(true);
    console.log("ClientFiling##", isLoadingTable);
    try {
      console.log("sendMasterApprover", data);
      let postObj = [];
      // Object.entries(data).forEach(([i, states]) => {
      //   console.log("sendMasterApprover ele", states);
      data.forEach((ele) => {
        postObj.push({
          approverId: ele.approverId,
          approverName: ele.approverName,
          customerId: ele.customerId,
          juristiction: ele.juristiction,
          state: ele.state,
          isdefault: ele.isdefault,
          approverGroupId: 1,
          filingType: "ClientFiling",
          createDate: new Date(),
          createUser: authUser.userId + "",
          // updateDate: 2023-03-28T03:53:25.589Z,
          //updateUser: authUser.userId + "",
        });
      });
      // });
      console.log("send data is passing", postObj);
      await axios
        .post(`${API_BASE_URL}/Application/CreateApprovers`, postObj)
        .then((res) => {
          console.log("send data res", res);
          if (res.data.errorMessage) {
            setAlertMessage(res.data.errorMessage);
            setShowAlert(true);
            handleReset();
          } else {
            // closeDialog();
            // showAlert("Success", "Successfully added Approver**", "success");
            console.log("SHOW ALERT");
            setAlertMessage("Successfully added Approver");
            setShowAlert(true);
            handleReset();
            getCustomerList();
          }
        })
        .catch((error) => {
          console.log("Error:", error);
          console.log("Error:", error.response?.data);
          // showAlert("Error", error.response?.data, "error");
          setAlertMessage(error.response?.data);
          setShowAlert(true);
          // closeDialog();
          handleReset();
        });
    } finally {
      setIsLoadingTable(false);
    }
  };
  const sendMasterApprover = async (data) => {
    setIsLoadingTable(true);
    console.log("masterFiling##", isLoadingTable);

    console.log("sendMasterApprover", data);

    let postObj = [];
    try {
      data.forEach((ele) => {
        postObj.push({
          approverId: ele.approverId,
          approverName: ele.approverName,
          customerId: ele.customerId,
          juristiction: ele.juristiction,
          state: ele.state,
          isdefault: ele.isdefault,
          filingType: "MasterFiling",
          approverGroupId: 1,
          createDate: new Date(),
          createUser: authUser.userId + "",
          // updateDate: 2023-03-28T03:53:25.589Z,
          //updateUser: authUser.userId + "",
        });
      });
      console.log("sendMasterApprover payload", postObj);
      await axios
        .post(`${API_BASE_URL}/Application/CreateApprovers`, postObj)
        .then((res) => {
          console.log("send data res", res);
          if (res.data.errorMessage) {
            // showAlert("Error", res.data.errorMessage, "error");
            // closeDialog();
            setAlertMessage(res.data.errorMessage);
            setShowAlert(true);
            handleMasterReset();
          } else {
            // closeDialog();
            // showAlert(
            //   "Success",
            //   "------------Successfully added Approver",
            //   "success"
            // );
            console.log("SHOW ALERT2");
            setAlertMessage("Successfully added Approver");
            setShowAlert(true);
            handleMasterReset();
            getCustomerList();
          }
        })
        .catch((error) => {
          console.log("Error:", error);
          // showAlert("Error", error.response?.data, "error");
          // closeDialog();
          setAlertMessage(error.response?.data);
          setShowAlert(true);
          handleMasterReset();
        });
    } finally {
      setIsLoadingTable(false);
    }
  };

  useEffect(() => {
    console.log("selectedApproverData", selectedApproverData);
  }, [selectedApproverData]);

  //Collect Approver Data
  const collectApproverData = () => {
    let isSelectedState =
      selectedRadio === "State" ? selectedState.length > 0 : true;
    console.log(
      "collectApproverData",
      value,
      name,
      selectedRadio,
      isSelectedState
    );
    const isValid = validate();
    if (isValid) {
      if (
        name !== "" &&
        value !== "" &&
        selectedRadio !== "" &&
        isSelectedState
      ) {
        let selectedApprover;
        selectedApprover = JSON.parse(JSON.stringify(approverTableData));
        selectedApprover[name] = selectedApprover[name] ?? [];

        let payload = [];
        let showAlert = false;
        if (selectedRadio === "Federal") {
          selectedApprover[name]["Federal"] =
            selectedApprover[name]["Federal"] ?? [];
          if (
            selectedApprover[name]["Federal"].some(
              (approver) => approver.approverId === approverId
            )
          ) {
            setAlertMessage(`Approver already exists for Federal`);
            setShowAlert(true);
            handleReset();
          } else {
            payload.push({
              customerName: name,
              approverName: value,
              juristiction: "Federal",
              state: null,
              customerId: customerId,
              approverId: approverId,
              isdefault: selectedApprover[name]["Federal"].length <= 0,
            });
          }
        } else {
          selectedState.forEach((ele) => {
            selectedApprover[name][ele] = selectedApprover[name][ele] ?? [];
            let approverExists = selectedApprover[name][ele].some(
              (approver) => approver.approverId === approverId
            );
            console.log("approver exist", approverExists);
            if (approverExists) {
              setAlertMessage(`Approver already exists for ${ele}`);
              setShowAlert(true);
              handleReset();
            } else {
              payload.push({
                customerName: name,
                approverName: value,
                juristiction: "State",
                state: ele,
                customerId: customerId,
                approverId: approverId,
                isdefault: selectedApprover[name][ele].length <= 0,
              });
            }
          });
        }
        // if (showAlert) {
        //   if (selectedRadio === "Federal") {
        //     setAlertMessage("Approver already exists!");
        //   }
        //   else {
        //     setAlertMessage(`Approver already exists for ${showAlert}` );
        //   }
        //   setShowAlert(true);
        //   handleReset();

        // } else {
        // process payload here
        if (payload.length > 0) {
          sendApprover(payload).then(() => {
            console.log(
              "selectedApprover isClient ->",
              selectedApprover,
              approverTableData
            );

            // setShowAlert(true);
            // handleReset();
            // getCustomerList();
          });
        }
        // setAlertMessage("Successfully added Approver")

        // }

        // if (selectedApproverData.length > 0) {
        //   selectedApprover = [...selectedApproverData];
        //   let isClient = selectedApprover.filter((ele) => ele.client === name);
        //   console.log("selectedApprover isClient", isClient);
        //   if (isClient.length > 0) {
        //     if (selectedRadio === "Federal") {
        //       let isFederal = isClient[0].states.filter(
        //         (ele) => ele.state === "Federal"
        //       );
        //       console.log("selectedApprover isFederal", isFederal);
        //       if (isFederal.length > 0) {
        //         let isApprover = isFederal[0].approvers.filter(
        //           (ele) => ele.ApproverName === value
        //         );
        //         console.log(
        //           "selectedApprover isApprover",
        //           isApprover,
        //           isApprover.length <= 0
        //         );
        //         if (isApprover.length <= 0) {
        //           let newApprover = {
        //             ApproverName: value,
        //             id: approverId,
        //             isDefault: false,
        //           };
        //           isFederal[0].approvers.push(newApprover);
        //         }
        //       } else {
        //         let newFederal = {
        //           state: "Federal",
        //           approvers: [
        //             { ApproverName: value, id: approverId, isDefault: true },
        //           ],
        //         };

        //         isClient[0].states.push(newFederal);
        //       }
        //     } else {
        //       selectedState.forEach((state) => {
        //         let isState = isClient[0].states.filter(
        //           (ele) => ele.state === state
        //         );
        //         console.log("selectedApprover isState", isState);
        //         if (isState.length > 0) {
        //           let isApprover = isState[0].approvers.filter(
        //             (ele) => ele.ApproverName === value
        //           );
        //           console.log(
        //             "selectedApprover isApprover",
        //             isApprover,
        //             isApprover.length <= 0
        //           );
        //           if (isApprover.length <= 0) {
        //             let newApprover = {
        //               ApproverName: value,
        //               id: approverId,
        //               isDefault: false,
        //             };
        //             isState[0].approvers.push(newApprover);
        //           }
        //         } else {
        //           let newState = {
        //             state: state,
        //             approvers: [
        //               { ApproverName: value, id: approverId, isDefault: true },
        //             ],
        //           };
        //           isClient[0].states.push(newState);
        //           console.log(
        //             "selectedApprover newState",
        //             newState,
        //             selectedApprover
        //           );
        //         }
        //       });
        //     }
        //   } else {
        //     let newClient = {
        //       client: name,
        //       customerId: customerId,
        //       states:
        //         selectedRadio === "Federal"
        //           ? [
        //               {
        //                 state: "Federal",
        //                 approvers: [
        //                   {
        //                     ApproverName: value,
        //                     id: approverId,
        //                     isDefault: true,
        //                   },
        //                 ],
        //               },
        //             ]
        //           : selectedState.map((ele) => ({
        //               state: ele,
        //               approvers: [
        //                 { ApproverName: value, id: approverId, isDefault: true },
        //               ],
        //             })),
        //     };
        //     selectedApprover.push(newClient);
        //     console.log(
        //       "selectedApprover newClient",
        //       newClient,
        //       selectedApprover
        //     );
        //   }
        // } else {
        //   selectedApprover = [
        //     {
        //       client: name,
        //       customerId: customerId,
        //       states:
        //         selectedRadio === "Federal"
        //           ? [
        //               {
        //                 state: "Federal",
        //                 approvers: [
        //                   {
        //                     ApproverName: value,
        //                     id: approverId,
        //                     isDefault: true,
        //                   },
        //                 ],
        //               },
        //             ]
        //           : selectedState.map((ele) => ({
        //               state: ele,
        //               approvers: [
        //                 { ApproverName: value, id: approverId, isDefault: true },
        //               ],
        //             })),
        //     },
        //   ];
        // }
        // setSelectedApproverData(selectedApprover);
        // console.log("selectedApprover array ->", selectedApprover);
      }
    }
  };
  const collectMasterApproverData = () => {
    console.log(
      "collectMasterApproverData",
      masterSelectedApproverData,
      masterApproverList,
      masterSelectedRadio,
      masterSelectedState
    );

    const isValid = validateMaster();
    console.log("Valid", isValid);
    if (isValid) {
      let isSelectedState =
        masterSelectedRadio === "State" ? masterSelectedState.length > 0 : true;
      if (
        masterApproverList !== "" &&
        masterSelectedRadio !== "" &&
        masterSelectedRadio !== " " &&
        masterSelectedState
      ) {
        let selectedApprover;
        selectedApprover = JSON.parse(JSON.stringify(approverMasterTableData));

        let payload = [];
        let showAlert = false;
        if (masterSelectedRadio === "Federal") {
          selectedApprover["Federal"] = selectedApprover["Federal"] ?? [];
          if (
            selectedApprover["Federal"].some(
              (approver) => approver.approverId === masterApproverId
            )
          ) {
            setAlertMessage(`Approver already exists for Federal`);
            setShowAlert(true);
            handleMasterReset();
          } else {
            payload.push({
              approverName: masterApproverList,
              juristiction: "Federal",
              state: null,
              approverId: masterApproverId,
              isdefault: selectedApprover["Federal"].length <= 0,
            });
          }
        } else {
          masterSelectedState.forEach((ele) => {
            selectedApprover[ele] = selectedApprover[ele] ?? [];
            let approverExists = selectedApprover[ele].some(
              (approver) => approver.approverId === masterApproverId
            );
            console.log("approver exist", approverExists);
            if (approverExists) {
              setAlertMessage(`Approver already exists for ${ele}`);
              setShowAlert(true);
              handleMasterReset();
            } else {
              payload.push({
                approverName: masterApproverList,
                juristiction: "State",
                state: ele,
                approverId: masterApproverId,
                isdefault: selectedApprover[ele].length <= 0,
              });
            }
          });
        }
        // if (showAlert) {
        //   if (selectedRadio === "Federal") {
        //     setAlertMessage("Approver already exists!");
        //   }
        //   else {
        //     setAlertMessage(`Approver already exists for ${showAlert}` );
        //   }
        //   setShowAlert(true);
        //   handleReset();
        // }
        if (payload.length > 0) {
          sendMasterApprover(payload).then(() => {
            console.log(
              "selectedApprover isClient ->",
              selectedApprover,
              approverTableData
            );
            //  setAlertMessage("Successfully added Approver");
            //  setShowAlert();
            // setAlertMessage("Successfully added Approver");
            // setShowAlert(true);
            // handleMasterReset();
          });
        }
        //   });
        // if (masterSelectedApproverData.length > 0) {

        //   if (masterSelectedRadio === "Federal") {
        //     let isFederal = selectedApprover[0].states.filter(
        //       (ele) => ele.state === "Federal"
        //     );
        //     console.log("selectedApprover isFederal", isFederal);
        //     if (isFederal.length > 0) {
        //       let isApprover = isFederal[0].approvers.filter(
        //         (ele) => ele.ApproverName === masterApproverList
        //       );
        //       console.log(
        //         "selectedApprover isApprover",
        //         isApprover,
        //         isApprover.length <= 0
        //       );
        //       if (isApprover.length <= 0) {
        //         let newApprover = {
        //           ApproverName: masterApproverList,
        //           id: masterApproverId,
        //           isDefault: false,
        //         };
        //         isFederal[0].approvers.push(newApprover);
        //       }
        //     } else {
        //       let newFederal = {
        //         state: "Federal",
        //         approvers: [
        //           {
        //             ApproverName: masterApproverList,
        //             id: masterApproverId,
        //             isDefault: true,
        //           },
        //         ],
        //       };
        //       selectedApprover[0].states.push(newFederal);
        //     }
        //   } else {
        //     masterSelectedState.forEach((state) => {
        //       let isState = selectedApprover[0].states.filter(
        //         (ele) => ele.state === state
        //       );
        //       console.log("selectedApprover isState", isState);
        //       if (isState.length > 0) {
        //         let isApprover = isState[0].approvers.filter(
        //           (ele) => ele.ApproverName === masterApproverList
        //         );
        //         console.log(
        //           "selectedApprover isApprover",
        //           isApprover,
        //           isApprover.length <= 0
        //         );
        //         if (isApprover.length <= 0) {
        //           let newApprover = {
        //             ApproverName: masterApproverList,
        //             id: masterApproverId,
        //             isDefault: false,
        //           };
        //           isState[0].approvers.push(newApprover);
        //         }
        //       } else {
        //         let newState =
        //           masterSelectedRadio === "Federal"
        //             ? {
        //                 state: "Federal",
        //                 approvers: [
        //                   {
        //                     ApproverName: masterApproverList,
        //                     id: masterApproverId,
        //                     isDefault: true,
        //                   },
        //                 ],
        //               }
        //             : {
        //                 state: state,
        //                 approvers: [
        //                   {
        //                     ApproverName: masterApproverList,
        //                     id: masterApproverId,
        //                     isDefault: true,
        //                   },
        //                 ],
        //               };
        //         selectedApprover[0].states.push(newState);
        //         console.log(
        //           "selectedApprover newState",
        //           newState,
        //           selectedApprover
        //         );
        //       }
        //     });
        //   }
        // } else {
        //   selectedApprover = [
        //     {
        //       states:
        //         masterSelectedRadio === "Federal"
        //           ? [
        //               {
        //                 state: "Federal",
        //                 approvers: [
        //                   {
        //                     ApproverName: masterApproverList,
        //                     id: masterApproverId,
        //                     isDefault: true,
        //                   },
        //                 ],
        //               },
        //             ]
        //           : masterSelectedState.map((ele) => ({
        //               state: ele,
        //               approvers: [
        //                 {
        //                   ApproverName: masterApproverList,
        //                   id: masterApproverId,
        //                   isDefault: true,
        //                 },
        //               ],
        //             })),
        //     },
        //   ];
        // }
        // setMasterSelectedApproverData(selectedApprover);
        // console.log("array", selectedApprover);
      }
    }
  };

  //Handle Reset
  const handleReset = () => {
    setName("");
    setValue("");
    setSelectedState([]);
    setSelectedApproverData([]);
  };
  const handleMasterReset = (type) => {
    setMasterApproverList("");
    setMasterSelectedState([]);
    setMasterSelectedApproverData([]);
  };

  //Handle Name Change
  const nameChange = (event, value) => {
    console.log("nameChange value", value);
    setName(value);
    if (value) {
      const customer = customerList.find((obj) => obj.customerName === value);
      setCustomerId(customer.customerId);
      console.log("nameChange approverList", approverList);
      let clientApprovers = approverList.filter(
        (ele) =>
          ele.roleName === "Admin" ||
          ((ele.roleName === "JSISME" || ele.roleName === "JSIPOC") &&
            ele.customerId === customer.customerId)
      );
      console.log("nameChange clientApprovers", clientApprovers);
      setClientApproverList(clientApprovers);
    } else {
      setCustomerId(null);
    }
  };

  //Handle Approver List Change
  const handlenameChange = (event, value) => {
    console.log("value", value);
    setValue(value);
    if (value) {
      const approver = approverList.find((obj) => obj.userName === value);
      setApproverId(approver.userId);
    } else {
      setApproverId(null);
    }
  };

  const handleMasterApproverList = (event) => {
    setMasterApproverList(event.target.value);
    approverList.forEach((obj) => {
      if (obj.userName == event.target.value) {
        setMasterApproverId(obj.userId);
      }
    });
    console.log(masterApproverId);
  };

  //Handle Radio Change
  const handleRadioChange = (event) => {
    setSelectedRadio(event.target.value);
    console.log("val", selectedRadio);
  };
  const handleMasterRadioChange = (event) => {
    setMasterSelectedRadio(event.target.value);
    if (event.target.value === "Federal") {
      setMasterSelectedState([]);
    }
    console.log("val", masterSelectedRadio);
  };

  //Handle Tab Change
  const handleTabChange = (event, newValue) => {
    console.log("handleTabChange", event, newValue);
    setTabValue(newValue);
    setSelectedRecord([])
  };

  //Handle Delete
  const deleteTableFunc = async () => {
    setIsLoadingTable(true);
    console.log("handleDelete", deleteData, approverTableData);
    console.log("deleteClientFiling", deleteData);
    // let newTableData = { ...approverTableData };
    // let stateName =
    //   deleteData.stateName === null ? "Federal" : deleteData.stateName;
    // let findState = newTableData[deleteData.client][stateName].filter(
    //   (state) => {
    //     console.log("handleDelete removeApprover", state);
    //     return state.id !== deleteData.approverId;
    //   }
    // );

    // console.log("handleDelete removeApprover payload------>", findState[0]);
    try {
      await axios
        .delete(
          `${API_BASE_URL}/Application/DeleteApprovers/${deleteData.approverId}`
        )
        .then(async (res) => {
          console.log("handleDelete", res);
          if (res.data.errorMessage) {
            // showAlert("Error", res.data.errorMessage, "error");
            // closeDialog();
            setAlertMessage(res.data.errorMessage);
            setShowAlert(true);
            handleReset();
          } else {
            // if (findState.length > 0 && deleteData.isdefault) {
            //   setIsDefaultData({
            //     defaultfor: "client",
            //     event: "",
            //     client: deleteData.client,
            //     stateName: deleteData.stateName,
            //     approverId: findState[0].id,
            //   });
            //   await isDefaultTableChange();
            // }
            // showAlert("Success", "Successfully deleted Approver", "success");
            // closeDialog();
            setAlertMessage("Successfully deleted Approver");
            setShowAlert(true);
            handleReset();
            getCustomerList();
          }
        });
      // await sendApprover();
      // await setApproverTableData(newTableData);
      SetDeleteData(null);
    } finally {
      setIsLoadingTable(false);
    }
  };

  const masterDeleteFunc = async () => {
    setIsLoadingTable(true);
    console.log("handleDelete", deleteData.stateName, deleteData.approverId);
    console.log(
      "deleteDataMasterFiling",
      deleteData.stateName,
      deleteData.approverId
    );

    try {
      await axios
        .delete(
          `${API_BASE_URL}/Application/DeleteApprovers/${deleteData.approverId}`
        )
        .then((res) => {
          console.log("handleDelete", res);
          if (res) {
            // let newTableData = { ...approverTableData };
            // let stateName =
            //   deleteData.stateName === null ? "Federal" : deleteData.stateName;
            // let findState = newTableData[deleteData.client][stateName].filter(
            //   (state) => {
            //     console.log("handleDelete removeApprover", state);
            //     return state.id !== deleteData.approverId;
            //   }
            // );
            setAlertMessage("Successfully deleted Approver");
            setShowAlert(true);
            handleReset();
            getCustomerList();
          } else {
            // showAlert("Error", "Unexpected Error", "error");
            // closeDialog();
            setAlertMessage("Unexpected Error");
            setShowAlert(true);
            handleReset();
          }
        });
      // let findState = masterSelectedApproverData.filter((ele) => {
      //   ele.states = ele.states.filter((state) => {
      //     if (state.state === deleteData.stateName) {
      //       state.approvers = state.approvers.filter(
      //         (ele) => ele.id !== deleteData.approverId
      //       );
      //     }
      //     console.log("handleDelete", state);
      //     if (state.approvers.length > 0) {
      //       state.approvers = state.approvers.map((ele, i) => {
      //         ele.isDefault = i === 0 ? true : false;
      //         return ele;
      //       });
      //       return state;
      //     }
      //   });
      //   console.log("handleDelete", ele);
      //   if (ele.states.length > 0) {
      //     return ele;
      //   }
      // });
      // console.log("handleDelete removeApprover", findState);
      // await setMasterSelectedApproverData(findState);
      SetDeleteData(null);
    } finally {
      setIsLoadingTable(false);
    }
  };

  //Handle State Change
  const stateChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedState(typeof value === "string" ? value.split(",") : value);
  };
  const masterStateChange = (event) => {
    const {
      target: { value },
    } = event;
    setMasterSelectedState(
      typeof value === "string" ? value.split(",") : value
    );
  };

  //isDefaut Change
  // const isDefaultMasterChange = (event, stateName, approverId) => {
  //   console.log(
  //     "isDefaultMasterChange",
  //     masterSelectedApproverData,
  //     event.target.value,
  //     stateName,
  //     approverId
  //   );
  //   let findState = masterSelectedApproverData.filter((ele) => {
  //     ele.states = ele.states.filter((state) => {
  //       if (state.state === stateName) {
  //         state.approvers = state.approvers.map((ele) => {
  //           if (ele.id === approverId) {
  //             ele.isDefault = true;
  //           } else {
  //             ele.isDefault = false;
  //           }
  //           return ele;
  //         });
  //       }
  //       console.log("handleDelete", state);
  //       if (state.approvers.length > 0) {
  //         return state;
  //       }
  //     });
  //     console.log("handleDelete", ele);
  //     if (ele.states.length > 0) {
  //       return ele;
  //     }
  //   });
  //   console.log("handleDelete isDefaultChange", findState);
  //   setMasterSelectedApproverData(findState);
  // };

  // const isDefaultChange = (event, client, stateName, approverId) => {
  //   console.log(
  //     "isDefaultChange",
  //     selectedApproverData,
  //     event.target.value,
  //     client,
  //     stateName,
  //     approverId
  //   );
  //   let findClient = selectedApproverData.filter((ele) => {
  //     if (ele.client === client) {
  //       ele.states = ele.states.filter((state) => {
  //         if (state.state === stateName) {
  //           state.approvers = state.approvers.map((ele) => {
  //             if (ele.id === approverId) {
  //               ele.isDefault = true;
  //             } else {
  //               ele.isDefault = false;
  //             }
  //             return ele;
  //           });
  //         }
  //         console.log("handleDelete", state);
  //         if (state.approvers.length > 0) {
  //           return state;
  //         }
  //       });
  //     }
  //     console.log("handleDelete", ele);
  //     if (ele.states.length > 0) {
  //       return ele;
  //     }
  //   });
  //   console.log("handleDelete isDefaultChange", findClient);
  //   setSelectedApproverData(findClient);
  // };

  const getCurrentApprover = (client, stateName) => {
    let state = stateName === null ? "Federal" : stateName;
    let CurrApprover;
    if (client) {
      let newTableData = { ...approverTableData };
      CurrApprover = newTableData[client][state].filter((item) => {
        console.log("Find Current Approver", item);
        return item.isdefault;
      });
    } else {
      let newTableData = { ...approverMasterTableData };
      CurrApprover = newTableData[state].filter((item) => {
        console.log("Find Current Approver", item);
        return item.isdefault;
      });
    }
    console.log("Find Rec for :", client, stateName);
    console.log("Find in :", approverTableData, typeof approverTableData);
    console.log("Found Approver:", CurrApprover);
    return CurrApprover[0]?.approverId;
  };

  const isDefaultDialog = (
    event,
    client,
    stateName,
    approverId,
    customerId
  ) => {
    console.log("change Default e: ", event);
    const oldApproverId = getCurrentApprover(client, stateName);
    setIsDefaultData({
      defaultfor: "client",
      event,
      client,
      stateName,
      approverId,
      oldApproverId,
      customerId,
    });
    openConfirmDialog(
      "Confirmation",
      "Are you sure you want to make this Approver default and reassign pending workflow(s)?"
    );
  };

  const isDefaultMasterDialog = (event, stateName, approverId) => {
    const oldApproverId = getCurrentApprover(null, stateName);
    setIsDefaultData({
      defaultfor: "master",
      event,
      stateName,
      approverId,
      oldApproverId,
    });
    openConfirmDialog(
      "Confirmation",
      "Are you sure you want to make this Approver default and reassign pending workflow(s)?"
    );
  };

  const isDefaultTableChange = () => {
    console.log(
      "isDefaultChange",
      selectedApproverData,
      isDefaultData.client,
      isDefaultData.stateName,
      isDefaultData.approverId,
      isDefaultData.oldApproverId,
      isDefaultData.customerId
    );
    console.log("isDefaultChange1", selectedApproverData);

    let newTableData = JSON.parse(JSON.stringify(approverTableData));
    let isState =
      isDefaultData.stateName === null ? "Federal" : isDefaultData.stateName;
    let findState = newTableData[isDefaultData.client][isState].map((state) => {
      console.log(
        "handleDelete isDefaultChange",
        state.id,
        isDefaultData.approverId
      );
      if (state.approverId === isDefaultData.approverId) {
        state.isdefault = true;
      } else {
        state.isdefault = false;
      }
      return state;
    });
    console.log("handleDelete isDefaultChange", findState, newTableData);
    newTableData[isDefaultData.client][isState] = findState;
    // setIsDefaultData(null);
    // SetDeleteData({
    //   changeApproverFor: "client",
    //   approverData: newTableData[isDefaultData.client],
    // });
    // showDialog;
    updateApprover(newTableData[isDefaultData.client]);
    // let findClient = selectedApproverData.filter((ele) => {
    //   if (ele.client === client) {
    //     ele.states = ele.states.filter((state) => {
    //       if (state.state === stateName) {
    //         state.approvers = state.approvers.map((ele) => {
    //           if (ele.id === approverId) {
    //             ele.isDefault = true;
    //           } else {
    //             ele.isDefault = false;
    //           }
    //           return ele;
    //         });
    //       }
    //       console.log("handleDelete", state);
    //       if (state.approvers.length > 0) {
    //         return state;
    //       }
    //     });
    //   }
    //   console.log("handleDelete", ele);
    //   if (ele.states.length > 0) {
    //     return ele;
    //   }
    // });
    // console.log("handleDelete isDefaultChange", newTableData);
    // setApproverTableData(newTableData);
  };

  const isDefaultMasterTableChange = () => {
    console.log(
      "isDefaultChange",
      approverMasterTableData,
      isDefaultData.stateName,
      isDefaultData.approverId,
      isDefaultData.oldApproverId
    );
    console.log(
      "isDefaultChange2",
      approverMasterTableData,
      isDefaultData.stateName,
      isDefaultData.approverId,
      isDefaultData.oldApproverId
    );

    let newTableData = JSON.parse(JSON.stringify(approverMasterTableData));
    let isState =
      isDefaultData.stateName === null ? "Federal" : isDefaultData.stateName;
    let findState = newTableData[isState].map((state) => {
      console.log(
        "handleDelete isDefaultChange",
        state.id,
        isDefaultData.approverId
      );
      if (state.approverId === isDefaultData.approverId) {
        state.isdefault = true;
      } else {
        state.isdefault = false;
      }
      return state;
    });
    console.log("handleDelete isDefaultChange", findState, newTableData);
    newTableData[isState] = findState;
    // setIsDefaultData(null);
    updateMasterApprover(newTableData[isState]);
  };

  const defaultChange = () => {
    setOpenChangeDefault(true);
  };

  const handleSubmit = () => {
    if (deleteData?.deletefor === "client") {
      deleteTableFunc();
    } else if (deleteData?.deletefor === "master") {
      masterDeleteFunc();
    } else if (isDefaultData?.defaultfor === "client") {
      isDefaultTableChange();
    } else if (isDefaultData?.defaultfor === "master") {
      isDefaultMasterTableChange();
    }
  };

  const openConfirmDialog = (header, message) => {
    setConfirmHeader(header || "Confirmation");
    setConfirmMessage(message || "");
    setShowConfirmDialog(true);
  };

  const closeConfirmDialog = () => {
    setShowConfirmDialog(false);
  };

  const handleConfirmSubmit = () => {
    handleSubmit();
    closeConfirmDialog();
  };

  //Handle Delete
  const handleDelete = (
    client,
    stateName,
    approverId,
    isdefault,
    approverName
  ) => {
    console.log("handleDelete", client, stateName, approverTableData);
    let state = stateName === null ? "Federal" : stateName;
    console.log(
      "handleDelete",
      Object.keys(approverTableData[client]).length,
      Object.keys(approverTableData[client][state]).length
    );
    let onlyApprover =
      Object.keys(approverTableData[client]).length > 1
        ? false
        : Object.keys(approverTableData[client][state]).length > 1
          ? false
          : true;
    console.log("handleDelete", onlyApprover);
    if (isdefault) {
      SetDeleteData(null);
      setAlertMessage(
        "Default approver cannot be deleted. Please assign/add another approver as default before delete ."
      );
      setShowAlert(true);
    } else {
      SetDeleteData({
        deletefor: "client",
        client,
        stateName,
        approverId,
        isdefault,
        approverName,
      });
      console.log(
        "handleDelete",
        client,
        stateName,
        approverId,
        isdefault,
        approverName
      );
      console.log("approverName$", approverName);
      openConfirmDialog(
        "Confirmation",
        <Typography>
          Are you sure to delete this Approver: {" "}
          <Typography fontWeight="bold" component="span">
            {approverName}?
          </Typography> {" "}
        </Typography>
      );
    }
  };

  const handleMasterDelete = (
    stateName,
    approverId,
    isdefault,
    approverName
  ) => {
    console.log("handleDelete", stateName, approverMasterTableData);
    let state = stateName === null ? "Federal" : stateName;
    console.log(
      "handleDelete",
      Object.keys(approverMasterTableData[state]).length
    );
    let onlyApprover =
      Object.keys(approverMasterTableData[state]).length > 1 ? false : true;
    console.log("handleDelete", onlyApprover);
    if (isdefault) {
      SetDeleteData(null);
      setAlertMessage(
        "Default approver cannot be deleted. Please assign/add another approver as default before delete ."
      );
      setShowAlert(true);
    } else {
      SetDeleteData({
        deletefor: "master",
        stateName,
        approverId,
        isdefault,
        approverName,
      });
      console.log(
        "handleDelete",
        stateName,
        approverId,
        isdefault,
        approverName
      );
      console.log("approverName$$", approverName);
      openConfirmDialog(
        "Confirmation",
        <Typography>
          Are you sure to delete this Approver: {" "}
          <Typography fontWeight="bold" component="span">
            {approverName}?
          </Typography> {" "}
        </Typography>
      );
    }
  };

  const closeAlert = () => {
    setShowAlert(false);
    // navigate("/");
  };
  // const { AlertDialog, showDialog: showAlert } = useDialog({});

  const displayHistory = async () => {
    console.log("displayHistory", selectedRecord)
    if (selectedRecord.length === 1) {
      try {
        const history = await axios.get(
          `${API_BASE_URL}/Application/ClientAndMasterApproversAudit?ID=${selectedRecord[0]}`
        );
        console.log(",displayHistory", history)
        setActivityHistory(() => history.data.data);
        setShowHistory(() => true);
      } catch (error) {
        console.log("@@Error:", error);
      }
    } else {
      setAlertMessage(`Please Select a single Approver`);
      setShowAlert(true);
    }
  }

  const closeHistory = () => {
    // console.log("Toggling Show Filter", showHistory);
    setShowHistory(() => false);
  };

  // ONLY layout sections changed — logic untouched

  return (
    <Fragment>

      <Grid sx={{ width: "100%", padding: "1rem" }}>
        <Box
          sx={{
            backgroundColor: tokens.colors.offWhite,
            borderRadius: "8px",
            padding: "2rem",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >

          <TabContext value={tabValue}>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                mb: 2
              }}
            >

              <style>{`
                .tracknow-approval-config-heading {
                  font-family: sans-serif !important;
                  font-weight: 600 !important;
                  font-size: 1rem !important;
                  letter-spacing: 0.02em !important;
                  margin: 0 !important;
                }
              `}</style>

              <h3 className="tracknow-approval-config-heading">
                APPROVER CONFIGURATION
              </h3>

              <TabList onChange={handleTabChange}>
                <Tab label="Client Filing" value="1" />
                <Tab label="Master Filing" value="2" />
              </TabList>

            </Box>

          <TabPanel value="1">
            <Grid style={{ display: "flex", justifyContent: "center" }}>
              <Grid>
                <Box
                  sx={{
                    display: "flex",
                    "& > :not(style)": {
                      m: 1,
                      width: 368,
                      height: 368,
                      backgroundColor: tokens.colors.offWhite,
                      overflow: "auto",
                      border: "1px solid #bcb6c8",
                      borderRadius: "12px",
                    },
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{ border: "1px solid #bcb6c8", borderRadius: "12px" }}
                  >
                    <FormControl sx={{ m: 1, minWidth: 280, width: "10%" }}>
                      <TrackNowSelect
                        value={name}
                        onChange={(e) => nameChange(null, e.target.value)}
                        label="Select Client *"
                        style={{ width: 340, marginLeft: "3%" }}
                        onFocus={() => handleFocus("name")}
                        displayEmpty
                        sx={{ width: "100%" }}
                        onFocus={() => handleFocus("name")}
                      >

                        <MenuItem value="">Choose client</MenuItem>

                        {customerList
                          .filter(customer => customer.trackNowLicenseId > 0)
                          .map((customer) => (
                            <MenuItem key={customer.customerId} value={customer.customerName}>
                              {customer.customerName.length > 35 ? (
                                <Tooltip title={customer.customerName} arrow>
                                  <span>{customer.customerName.substring(0, 35)}...</span>
                                </Tooltip>
                              ) : (
                                customer.customerName
                              )}
                            </MenuItem>
                          ))}

                      </TrackNowSelect>

                      {errors.name && (
                        <FormHelperText error={errors.name ? true : false}>
                          {errors.name}
                        </FormHelperText>
                      )}


                    </FormControl>

                    <FormControl sx={{ m: 1, minWidth: 280, width: "10%" }}>
                      <TrackNowSelect
                        value={value}
                        onChange={(e) => handlenameChange(null, e.target.value)}
                        label="Approver Lists *"
                        style={{ width: 340, marginLeft: "3%" }}
                        onFocus={() => handleFocus("value")}
                        displayEmpty
                        sx={{ width: "100%" }}
                        onFocus={() => handleFocus("value")}
                      >

                        <MenuItem value="">Choose approver</MenuItem>

                        {clientApproverList.map((approver) => (
                          <MenuItem
                            key={approver.userId}
                            value={approver.userName}
                          >
                            {approver.userName}
                          </MenuItem>
                        ))}

                      </TrackNowSelect>

                      {errors.value && (
                        <FormHelperText error={errors.value ? true : false}>
                          {errors.value}
                        </FormHelperText>
                      )}

                    </FormControl>

                  </Paper>
                </Box>
              </Grid>

              <Grid>
                <Box
                  sx={{
                    display: "flex",
                    "& > :not(style)": {
                      m: 1,
                      width: 368,
                      height: 368,
                      backgroundColor: tokens.colors.offWhite,
                      overflow: "auto",
                      marginLeft: "-8px",
                      border: "1px solid #bcb6c8",
                      borderRadius: "12px",
                    },
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{ border: "1px solid #bcb6c8", borderRadius: "12px" }}
                  >
                    <h5
                      style={{
                        marginLeft: "20px",
                        fontWeight: "500",
                        fontSize: "0.9rem",
                        textColor: "black",
                      }}
                    >
                      JURISDICTION *
                    </h5>
                    <FormControl>

                      <RadioGroup
                        row
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue={selectedRadio}
                        name="radio-buttons-group"
                        required={true}
                      >

                        <FormControlLabel
                          value="State"
                          control={<TrackNowRadio />}
                          label="State"
                          //  style={{ marginLeft: "10px" }}
                          onChange={handleRadioChange}
                          onFocus={() => handleFocus("radio")} />

                        <FormControlLabel
                          value="Federal"
                          control={<TrackNowRadio />}
                          label="Federal"
                          //  style={{ marginLeft: "10px" }}
                          onChange={handleRadioChange}
                          onFocus={() => handleFocus("radio")} />

                      </RadioGroup>

                      {errors.radio &&
                        <FormHelperText error>{errors.radio}</FormHelperText>
                      }

                    </FormControl>

                    {selectedRadio == "State" ? (
                      <FormControl sx={{ m: 1, minWidth: 280, width: "100%" }}>
                        <TrackNowSelect
                          id="demo-multiple-checkbox"
                          multiple
                          label="Select State"
                          value={selectedState}
                          onChange={stateChange}
                          required={true}
                          displayEmpty
                          style={{
                            width: 340,
                            marginLeft: "3%",
                            backgroundColor: tokens.colors.offWhite,
                          }}
                          renderValue={(selected) =>
                            selected.length === 0 ? "Select State" : selected.join(", ")
                          }
                          onFocus={() => handleFocus("stateInfo")}
                        >
                          {states.map((item) => (
                            <MenuItem key={item.code} value={item.code}>
                              <Checkbox
                                checked={selectedState.indexOf(item.code) > -1}
                              />
                              {item.state}
                            </MenuItem>
                          ))}
                        </TrackNowSelect>
                        {errors.stateInfo && (
                          <FormHelperText error>
                            {errors.stateInfo}
                          </FormHelperText>
                        )}

                      </FormControl>
                    ) : (
                      ""
                    )}
                  </Paper>
                </Box>
                </Grid>

              <Grid>
                <Box
                  sx={{
                    display: "flex",
                    "& > :not(style)": {
                      m: 1,
                      width: 368,
                      height: 368,
                      backgroundColor: tokens.colors.offWhite,
                      overflow: "auto",
                      border: 0,
                    },
                  }}
                ></Box>

                <br></br>

                <Grid
                  style={{ display: "flex", justifyContent: "flex-end" }}
                ></Grid>
              </Grid>
            </Grid>
            <Grid
              style={{
                margin: "1rem",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <TrackNowButton
                variant="primary"
                onClick={collectApproverData}
                disabled={isLoadingTable}
              >
                Submit
              </TrackNowButton>
            </Grid>
            <Grid sx={{ minHeight: "90vh", height: "auto", width: "100%", marginTop: "2rem" }}>
              {isLoadingTable ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <div>
                    <CircularProgress />
                  </div>
                </Box>
              ) : (
                <ApproverTable
                  tableData={approverTableData}
                  handleDelete={handleDelete}
                  isDefaultChange={isDefaultDialog}
                  setSelectedRow={(row) => setSelectedTableRow(row)}
                  selectedRow={selectedTableRow}
                  setSelectedRecord={(records) => setSelectedRecord(records)}
                />
              )}
            </Grid>
          </TabPanel>
          <TabPanel value="2">
            <Grid style={{ display: "flex", justifyContent: "center" }}>
              <Grid>
                <Box
                  sx={{
                    display: "flex",
                    "& > :not(style)": {
                      m: 1,
                      width: 368,
                      height: 368,
                      backgroundColor: tokens.colors.offWhite,
                      overflow: "auto",
                      border: "1px solid #bcb6c8",
                      borderRadius: "12px",
                    },
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{ border: "1px solid #bcb6c8", borderRadius: "12px" }}
                  >
                    <FormControl sx={{ m: 1, minWidth: 280, width: "75%" }}>
                      <TrackNowSelect
                        sx={{ width: "100%" }}
                        id="demo-simple-select-helper"
                        value={masterApproverList}
                        label="Approver Lists *"
                        onChange={handleMasterApproverList}
                        style={{
                          width: 340,
                          marginLeft: "3%",
                          backgroundColor: tokens.colors.offWhite,
                        }}
                        onFocus={() => handleMasterFocus("masterApproverList")}
                        displayEmpty
                      >
                        <MenuItem value="">Choose approver</MenuItem>
                        {approverList.map((approver) => (
                          <MenuItem
                            key={approver.userId}
                            value={approver.userName}
                          >
                            {approver.userName}
                          </MenuItem>
                        ))}

                      </TrackNowSelect>

                      {masterErrors.masterApproverList && (
                        <FormHelperText error>
                          {masterErrors.masterApproverList}
                        </FormHelperText>
                      )}                    </FormControl>

                  </Paper>

                </Box>
                </Grid>

              <Grid>
                <Box
                  sx={{
                    display: "flex",
                    "& > :not(style)": {
                      m: 1,
                      width: 368,
                      height: 368,
                      backgroundColor: tokens.colors.offWhite,
                      overflow: "auto",
                      marginLeft: "-8px",
                      border: "1px solid #bcb6c8",
                      borderRadius: "12px",
                    },
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{ border: "1px solid #bcb6c8", borderRadius: "12px" }}
                  >
                    <h5
                      style={{
                        marginLeft: "20px",
                        fontWeight: "500",
                        fontSize: "0.9rem",
                        textColor: "black",
                      }}
                    >
                      JURISDICTION *
                    </h5>
                    <FormControl>

                      <RadioGroup
                        row
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue={masterSelectedRadio}
                        name="radio-buttons-group"
                      >

                        <FormControlLabel
                          value="State"
                          control={<TrackNowRadio />}
                          label="State"
                          onChange={handleMasterRadioChange}
                          onFocus={() => handleMasterFocus("masterRadio")} />

                        <FormControlLabel
                          value="Federal"
                          control={<TrackNowRadio />}
                          label="Federal"
                          onChange={handleMasterRadioChange}
                          onFocus={() => handleMasterFocus("masterRadio")} />

                      </RadioGroup>

                      {masterErrors.masterRadio && (
                        <FormHelperText error>
                          {masterErrors.masterRadio}
                        </FormHelperText>
                      )}
                    </FormControl>

                    {masterSelectedRadio == "State" ? (
                      <FormControl sx={{ m: 1, minWidth: 280, width: "100%" }}>
                        <TrackNowSelect
                          id="demo-multiple-checkbox"
                          multiple
                          label="Select State"
                          value={masterSelectedState}
                          onChange={masterStateChange}
                          displayEmpty
                          style={{
                            width: 340,
                            marginLeft: "3%",
                            backgroundColor: tokens.colors.offWhite,
                          }}
                          renderValue={(selected) =>
                            selected.length === 0 ? "Select State" : selected.join(", ")
                          }
                          onFocus={() => handleMasterFocus("masterSelectedState")}
                        >
                          {states.map((item) => (
                            <MenuItem key={item.code} value={item.code}>
                              <Checkbox
                                checked={
                                  masterSelectedState.indexOf(item.code) > -1
                                }
                              />
                              {item.state}
                            </MenuItem>
                          ))}
                        </TrackNowSelect>
                        {masterErrors.masterSelectedState && (
                          <FormHelperText error>
                            {masterErrors.masterSelectedState}
                          </FormHelperText>
                        )}
                      </FormControl>
                    ) : (
                      ""
                    )}
                  </Paper>
                </Box>

                </Grid>
            </Grid>
            <Grid style={{ display: "flex", justifyContent: "center" }}>
              <TrackNowButton
                variant="primary"
                disabled={isLoadingTable}
                onClick={collectMasterApproverData}
              >
                Submit
              </TrackNowButton>
            </Grid>
            <Grid sx={{ minHeight: "90vh", height: "auto", width: "100%", marginTop: "2rem" }}>
              {isLoadingTable ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <div>
                    <CircularProgress />
                  </div>
                </Box>
              ) : (
                  <ApproverTable
                    isMaster={true}
                    tableData={approverMasterTableData}
                    handleDelete={handleMasterDelete}
                    isDefaultChange={isDefaultMasterDialog}
                    setSelectedRow={(row) => setSelectedMasterTableRow(row)}
                    selectedRow={selectedMasterTableRow}
                    setSelectedRecord={(records) => setSelectedRecord(records)}
                  />
                )}

            </Grid>

            </TabPanel>

          </TabContext>

        </Box>

      </Grid>
      {/* <Grid
        sx={{
          height: "100%",
          width: "5%",
        }}
      >
        <div
          style={{
            height: "100%",
            background: "#F1F2F6",
            marginTop: "1rem",
            borderRadius: "2%",
          }}
        >
          <Item
            sx={{
              height: "100%",
            }}
          >
            <ApprovalConfigToolbox 
              displayHistory={displayHistory}
            />
          </Item>
        </div>
      </Grid> */}
      <CustomDialog
        header={confirmHeader}
        visible={showConfirmDialog}
        onHide={closeConfirmDialog}
        onConfirm={handleConfirmSubmit}
      >
        {confirmMessage}
      </CustomDialog>
      {/* {
        <ApprovalConfigHistory
          show={showHistory}
          dockAt="right"
          // tracker={selectedFiling[0]}
          activityHistory={activityHistory}
          handleClose={closeHistory}
        />
      } */}
      <CustomDialog
        header="Info"
        visible={showAlert}
        onHide={() => closeAlert()}
        footer={null}
      >

        {alertMessage}

      </CustomDialog>

    </Fragment>
  );
}
